import * as SwitchPrimitive from '@radix-ui/react-switch'
import { cn } from 'lib/utils'
import * as React from 'react'

function Switch({
  className,
  variant = 'default',
  ...props
}: React.ComponentProps<typeof SwitchPrimitive.Root> & {
  /** `default` — legacy purple primary. `dark` — T3 dual-theme (acid checked). */
  variant?: 'default' | 'dark'
}) {
  return (
    <SwitchPrimitive.Root
      data-slot="switch"
      className={cn(
        'peer inline-flex h-[1.15rem] w-8 shrink-0 items-center rounded-full transition-all outline-none disabled:cursor-not-allowed disabled:opacity-50',
        variant === 'default' &&
          'border border-transparent shadow-xs focus-visible:border-ring focus-visible:ring-[3px] focus-visible:ring-ring/50 data-[state=checked]:bg-primary data-[state=unchecked]:bg-input dark:data-[state=unchecked]:bg-input/80',
        variant === 'dark' &&
          'border border-line-bright bg-bg-3 focus-visible:ring-2 focus-visible:ring-acid focus-visible:ring-offset-2 focus-visible:ring-offset-bg',
        className
      )}
      {...props}
    >
      <SwitchPrimitive.Thumb
        data-slot="switch-thumb"
        className={cn(
          'pointer-events-none block size-4 rounded-full ring-0 transition-transform data-[state=checked]:translate-x-[calc(100%-2px)] data-[state=unchecked]:translate-x-0',
          variant === 'default' &&
            'bg-background dark:data-[state=checked]:bg-primary-foreground dark:data-[state=unchecked]:bg-foreground',
          // Track stays dark; only the knob is acid when checked.
          variant === 'dark' && 'data-[state=checked]:bg-acid data-[state=unchecked]:bg-paper-dim'
        )}
      />
    </SwitchPrimitive.Root>
  )
}

export { Switch }
